export default __webpack_public_path__ + "static/media/background_service_card_2.0ed2ce6a.png";